import React from 'react'
import {Header, List} from 'semantic-ui-react'

const CallServiceMock = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Call Service Mock</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Select service</List.Item>
        <List.Item>2. Click "Mock" tab</List.Item>
        <List.Item>3. Click desired environment</List.Item>
        <List.Item>4. Copy the "Mock Base URL"</List.Item>
        <List.Item>5. Paste base URL plus the desired resource path into an HTTP request (e.g. cURL,
          Postman)</List.Item>
        <List.Item>6. Send request</List.Item>
      </List>
    </div>
  )
}

export {CallServiceMock}

export default CallServiceMock